import React, { Component } from 'react';
import { Container, Row, UncontrolledAccordion, AccordionItem, AccordionHeader, UncontrolledTooltip } from 'reactstrap';
import { Puntaje } from './Puntaje';
function redondearHaciaArriba(valor: number): number {
    const decimal = valor % 1;
    return decimal >= 0.5 ? Math.ceil(valor) : Math.floor(valor);
}

export class DetalleScore extends Component {

    constructor(props) {
        super(props);
        this.state = { proveedor: props.proveedor };
    }

    render() {
        const factorSumaItems = [];
        if (this.state.proveedor.FactoresQueSuman !== undefined) {
            for (var i = 0; i < this.state.proveedor.FactoresQueSuman.length; i++) {
                factorSumaItems.push(
                    <AccordionItem className={"factor c" + this.state.proveedor.FactoresQueSuman[i].color}>
                        <AccordionHeader targetId={"collapseS" + i}>
                            <span>{redondearHaciaArriba(this.state.proveedor.FactoresQueSuman[i].valor)}%</span>
                            {this.state.proveedor.FactoresQueSuman[i].nombre}
                        </AccordionHeader>
                    </AccordionItem>
                )
            }
        }

        const factorRestaItems = [];
        if (this.state.proveedor.factoresQueRestan !== undefined) {
            for (var j = 0; j < this.state.proveedor.factoresQueRestan.length; j++) {
                factorRestaItems.push(
                    <AccordionItem className={"factor c" + this.state.proveedor.factoresQueRestan[j].ok}>
                        <AccordionHeader targetId={"collapseR" + j}>
                            <span>{redondearHaciaArriba(this.state.proveedor.factoresQueRestan[j].valor)}%</span>
                            {this.state.proveedor.factoresQueRestan[j].nombre}
                        </AccordionHeader>
                    </AccordionItem>
                )
            }
        }

        const factoresItemsColumn = []; const factoresItemsColumn2 = [];
        for (var k = 0; k < (factorSumaItems.length + factorRestaItems.length + 1); k++) {
            if (k < ((factorSumaItems.length + factorRestaItems.length) / 2))
                factoresItemsColumn.push(factorSumaItems[k]);
            else {
                if (k > factorSumaItems.length)
                    factoresItemsColumn2.push(factorRestaItems[k - (factorSumaItems.length + 1)]);
                else 
                    factoresItemsColumn2.push(factorSumaItems[k]);
            }
        }
        

        return (
            <Container>
                <Row>
                    <div className="col-4">
                        <div className="extra">
                            Por consultas comun&iacute;cate con el Centro de Atenci&oacute;n a Proveedores<br />
                            <a href="mailto:score@proveedoresypf.com">score@proveedoresypf.com</a>
                        </div>
                        <UncontrolledAccordion>
                            <AccordionItem className={"factor c" + this.state.proveedor.FactoresQueSuman[5].color} style={{ marginLeft: "18%", marginRight: "-18%" }} id="factor5">
                                <AccordionHeader targetId={"collapseS" + 5}>
                                    {this.state.proveedor.FactoresQueSuman[5].nombre}
                                    <span>{this.state.proveedor.FactoresQueSuman[5].color == 3 ? <> - </> : redondearHaciaArriba(this.state.proveedor.FactoresQueSuman[5].valor)}</span>
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="right" target="factor5" >
                                {this.state.proveedor.FactoresQueSuman[5].descripcion !== "" ? this.state.proveedor.FactoresQueSuman[5].descripcion : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>
                            <AccordionItem className={"factor c" + this.state.proveedor.FactoresQueSuman[4].color} id="factor4">
                                <AccordionHeader targetId={"collapseS" + 4}>
                                    {this.state.proveedor.FactoresQueSuman[4].nombre}
                                    <span>{this.state.proveedor.FactoresQueSuman[4].color == 3 ? <> - </> : redondearHaciaArriba(this.state.proveedor.FactoresQueSuman[4].valor)}</span>
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="right" target="factor4" >
                                {this.state.proveedor.FactoresQueSuman[4].descripcion !== "" ? this.state.proveedor.FactoresQueSuman[4].descripcion : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>
                            <AccordionItem className={"factor c" + this.state.proveedor.FactoresQueSuman[3].color} style={{ marginLeft: "-18%", marginRight: "18%"}} id="factor3">
                                <AccordionHeader targetId={"collapseS" + 3}>
                                    {this.state.proveedor.FactoresQueSuman[3].nombre}
                                    <span>{this.state.proveedor.FactoresQueSuman[3].color == 3 ? <> - </> : redondearHaciaArriba(this.state.proveedor.FactoresQueSuman[3].valor)}</span>
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="right" target="factor3" >
                                {this.state.proveedor.FactoresQueSuman[3].descripcion !== "" ? this.state.proveedor.FactoresQueSuman[3].descripcion : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>
                            <AccordionItem className={"factor c" + this.state.proveedor.FactoresQueSuman[0].color} id="factor0">
                                <AccordionHeader targetId={"collapseS" + 0}>
                                    {this.state.proveedor.FactoresQueSuman[0].nombre}
                                    <span>{this.state.proveedor.FactoresQueSuman[0].color == 3 ? <> - </> : redondearHaciaArriba(this.state.proveedor.FactoresQueSuman[0].valor)}</span>
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="right" target="factor0" >
                                {this.state.proveedor.FactoresQueSuman[0].descripcion !== "" ? this.state.proveedor.FactoresQueSuman[0].descripcion : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>
                            <AccordionItem className={"factor c" + this.state.proveedor.FactoresQueSuman[6].color} style={{ marginLeft: "18%", marginRight: "-18%" }} id="factor6">
                                <AccordionHeader targetId={"collapseS" + 6}>
                                    {this.state.proveedor.FactoresQueSuman[6].nombre}
                                    <span>{this.state.proveedor.FactoresQueSuman[6].color == 3 ? <> - </> : redondearHaciaArriba(this.state.proveedor.FactoresQueSuman[6].valor)}</span>
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="right" target="factor6" >
                                {this.state.proveedor.FactoresQueSuman[6].descripcion !== "" ? this.state.proveedor.FactoresQueSuman[6].descripcion : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>
                        </UncontrolledAccordion>
                    </div>
                    <div className="col-4">
                        {<Puntaje proveedor={this.state.proveedor}></Puntaje>}
                    </div>
                    <div className="col-4">
                        <div className="extra">
                            <a href="https://walink.co/013024" target="_blank"><img src="/chatbot.png" alt="Chatbot" /></a>
                        </div>
                        <UncontrolledAccordion style={{ textAlign: "center", marginTop: "30px"} }>
                            <AccordionItem className="factorr">
                                <div>
                                    {this.state.proveedor.factoresQueRestan[1].nombre}<br />
                                    {
                                        this.state.proveedor.factoresQueRestan[1].ok ? 
                                            <img src="/check-ok.svg" alt="ok" width="28px" />
                                            :
                                            <img src="/check-x.svg" alt="x" width="28px" />
                                    }
                                </div>
                            </AccordionItem>
                            <AccordionItem className="factorr">
                                <div>
                                    {this.state.proveedor.factoresQueRestan[2].nombre}<br/>
                                    {
                                        this.state.proveedor.factoresQueRestan[2].ok ?
                                            <img src="/check-ok.svg" alt="ok" width="28px" />
                                            :
                                            <img src="/check-x.svg" alt="x" width="28px" />
                                    }
                                </div>
                            </AccordionItem>
                            <AccordionItem className="factorr">
                                <div>
                                    {this.state.proveedor.factoresQueRestan[0].nombre} (**)<br />
                                    {
                                        this.state.proveedor.factoresQueRestan[0].ok  ?
                                            <img src="/check-ok.svg" alt="ok" width="28px" />
                                            :
                                            <img src="/check-x.svg" alt="x" width="28px" />
                                    }
                                </div>
                            </AccordionItem>
                        </UncontrolledAccordion>
                        <UncontrolledAccordion>
                            <AccordionItem className="factor neutro" id="factor1">
                                <AccordionHeader targetId={"collapseS" + 1} >
                                    <span style={{ float: "left", backgroundColor: "gray" }}>{this.state.proveedor.FactoresQueSuman[1].color === 3 ? <> - </> : redondearHaciaArriba(this.state.proveedor.FactoresQueSuman[1].valor)}</span>
                                    {this.state.proveedor.FactoresQueSuman[1].nombre} (*)
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="left" target="factor1" >
                                {this.state.proveedor.FactoresQueSuman[1].descripcion !== "" ? this.state.proveedor.FactoresQueSuman[1].descripcion : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>
                            <AccordionItem className="factor neutro" id="factor2">
                                <AccordionHeader targetId={"collapseS" + 2}>
                                    <span style={{ float: "left", backgroundColor: "gray" }}>{this.state.proveedor.FactoresQueSuman[2].color === 3 ? <> - </> : redondearHaciaArriba(this.state.proveedor.FactoresQueSuman[2].valor)}</span>
                                    {this.state.proveedor.FactoresQueSuman[2].nombre} (*)
                                </AccordionHeader>
                            </AccordionItem>
                            <UncontrolledTooltip placement="left" target="factor2" >
                                {this.state.proveedor.FactoresQueSuman[2].descripcion !== "" ? this.state.proveedor.FactoresQueSuman[2].descripcion : "Sin datos disponibles para este factor"}
                            </UncontrolledTooltip>
                        </UncontrolledAccordion>
                        <h6>* Estos factores no impactan en el puntaje final.</h6>
                        <h6>** Cuestionario de Debida Diligencia</h6>
                    </div>
                </Row>
            </Container>
        );
    }
}